import * as React from 'react';
import classnames from 'classnames';
import { PrimaryButton } from '@fluentui/react';
import { useBetreuerByKz } from 'api/betreuer';
import { Ansprechpartner } from 'api/ansprechpartner';
import { AnredeLabel, SpracheLabel } from 'utils/labels';
import { defaultSmDate, formatSmDate } from 'utils/formatter';
import { formStyles } from 'styles/formStyles';
import { Timestamps } from 'formComponents/Timestamps';

interface AnsprechpartnerItemProps {
    ansprechpartner: Ansprechpartner;
    editAnsprechpartner: () => void;
}

export const AnsprechpartnerItem: React.FC<AnsprechpartnerItemProps> = ({ ansprechpartner, editAnsprechpartner }) => {
    const betreuerByKz = useBetreuerByKz();

    return (
        <div
            className={classnames(formStyles.listItem, {
                [formStyles.archived]: ansprechpartner.archiv,
            })}
        >
            <div className={formStyles.topBlock}>
                <div>
                    <div className={formStyles.listTitle}>
                        {ansprechpartner.anrede &&
                            (AnredeLabel[ansprechpartner.anrede] || ansprechpartner.anrede) + ' '}
                        {ansprechpartner.titel && ansprechpartner.titel + ' '}
                        {ansprechpartner.name && ansprechpartner.name + ' '}
                    </div>
                </div>
                <div className={formStyles.archivedTest}>{ansprechpartner.archiv && '(archiviert)'}</div>
                <div>
                    <PrimaryButton
                        onClick={() => {
                            editAnsprechpartner();
                        }}
                        text="Bearbeiten"
                    />
                </div>
            </div>
            <div className={formStyles.twoColumnsBlock}>
                <div className={formStyles.firstColumn}>
                    {ansprechpartner.position && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Position:</div>
                            <div className={formStyles.dataValue}>
                                <strong>{ansprechpartner.position}</strong>
                            </div>
                        </div>
                    )}
                    {ansprechpartner.abteilung && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Abteilung:</div>
                            <div className={formStyles.dataValue}>
                                <strong>{ansprechpartner.abteilung}</strong>
                            </div>
                        </div>
                    )}
                    {ansprechpartner.userKz && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey}>MA:</div>
                            <div className={formStyles.dataValue}>
                                {ansprechpartner.userKz &&
                                    (betreuerByKz[ansprechpartner.userKz]
                                        ? betreuerByKz[ansprechpartner.userKz].name || ansprechpartner.userKz
                                        : ansprechpartner.userKz)}
                            </div>
                        </div>
                    )}
                    {ansprechpartner.gebDat && ansprechpartner.gebDat !== defaultSmDate && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Geb. Dat.:</div>
                            <div className={formStyles.dataValue}>{formatSmDate(ansprechpartner.gebDat, true)}</div>
                        </div>
                    )}
                    {ansprechpartner.briefanrede && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Briefanrede:</div>
                            <div className={formStyles.dataValue}>{ansprechpartner.briefanrede}</div>
                        </div>
                    )}
                    {ansprechpartner.eRechnung && <div className={formStyles.line}>Elektronische Rechnung!</div>}
                </div>
                <div className={formStyles.thirdColumn}>
                    {ansprechpartner.telefon && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Telefon:</div>
                            <div className={formStyles.dataValue}>
                                {ansprechpartner.telefon && (
                                    <a href={'tel: ' + ansprechpartner.telefon}>{ansprechpartner.telefon}</a>
                                )}
                            </div>
                        </div>
                    )}
                    {ansprechpartner.mobil && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Mobil:</div>
                            <div className={formStyles.dataValue}>
                                {ansprechpartner.mobil && (
                                    <a href={'tel: ' + ansprechpartner.mobil}>{ansprechpartner.mobil}</a>
                                )}
                            </div>
                        </div>
                    )}
                    {ansprechpartner.fax && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Fax:</div>
                            <div className={formStyles.dataValue}>{ansprechpartner.fax}</div>
                        </div>
                    )}
                    {ansprechpartner.mail && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Mail:</div>
                            <div className={formStyles.dataValue}>
                                {ansprechpartner.mail && (
                                    <a href={'mailto: ' + ansprechpartner.mail}>{ansprechpartner.mail}</a>
                                )}
                            </div>
                        </div>
                    )}
                    {ansprechpartner.sprache && (
                        <div className={formStyles.keyValueLine}>
                            <div className={formStyles.dataKey100}>Sprache:</div>
                            <div className={formStyles.dataValue}>
                                {SpracheLabel[ansprechpartner.sprache] || ansprechpartner.sprache}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <Timestamps
                modifiedDate={ansprechpartner.updDat}
                modifiedDecimalTime={ansprechpartner.updUhr}
                modifiedUser={ansprechpartner.updUser}
                showCreated={false}
            />
        </div>
    );
};
